import { ArticleProps, ArticlesBox } from "@foodpilot/foods";
import { useTheme } from "@mui/material";
import { CMSContentBlock, CMSPageSection, CMSSectionBlocksContent } from "src/api/client-api/cms/useGetOneContent";

const blockToArticle = (blocks: CMSContentBlock[]): ArticleProps[] => {
    const blocksForArticles = blocks.map((block, idx) => {
        const isFirst = idx === 0;

        const articleBlock: ArticleProps = {
            title: block.title,
            description: block.description ?? "",
            imageSrc: block.media?.url ?? "",
            isFirst: isFirst,
        };

        return articleBlock;
    });

    return blocksForArticles;
};

type CMSArticlesProps = {
    section: CMSPageSection<CMSSectionBlocksContent>;
};
export const CMSArticles = (props: CMSArticlesProps) => {
    const theme = useTheme();
    const { section } = props;
    const { blocks } = section;

    const articleBlocks = blockToArticle(blocks);
    return (
        <ArticlesBox
            articles={articleBlocks}
            sxProps={{
                "& p, div": {
                    whiteSpace: "pre-wrap",
                    my: theme.spacing(0),
                    a: {
                        color: theme.palette.primary[400],
                    },
                },
                "& hr": {
                    border: "none",
                    height: "1px",
                    backgroundColor: theme.palette.divider,
                    width: `calc(100% + ${theme.spacing(8)})`,
                    ml: theme.spacing(-4),
                    my: theme.spacing(2.25),
                },
                "& .label": {
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: theme.spacing(1),
                    padding: theme.spacing(0.5, 1),
                    backgroundColor: theme.palette.grey[200],
                },
            }}
        />
    );
};
